import { environment } from '../config';
export interface SessionUser { id: string; name: string; email: string; role: string }
export const SESSION_EVENT = 'mbd-auth-changed';
// Preserve existing production logins; never reuse those keys in a test build.
const namespace = environment.appEnv === 'production' ? '' : `mbd:${environment.appEnv}:${environment.apiUrl}:`;
export const sessionKeys = { token: `${namespace}auth_token`, user: `${namespace}auth_user` };
let inaccessible = false;
const notify = () => window.dispatchEvent(new Event(SESSION_EVENT));
function removeStoredSession() {
  try { localStorage.removeItem(sessionKeys.token); localStorage.removeItem(sessionKeys.user); }
  catch { inaccessible = true; }
}
export function getToken(): string | null {
  if (inaccessible) return null;
  try { return localStorage.getItem(sessionKeys.token); } catch { return null; }
}
export function readUser(): SessionUser | null {
  try {
    const token = getToken();
    const stored = localStorage.getItem(sessionKeys.user);
    const user = stored ? JSON.parse(stored) : null;
    if (token && user && typeof user.id === 'string' && typeof user.role === 'string') return user;
  } catch { /* Storage failures and damaged sessions return to signed-out UI. */ }
  removeStoredSession();
  return null;
}
export function saveSession(token: string, user: SessionUser) {
  try {
    localStorage.setItem(sessionKeys.token, token);
    localStorage.setItem(sessionKeys.user, JSON.stringify(user));
    inaccessible = false;
  } catch {
    removeStoredSession();
    throw new Error('Browser storage is unavailable. Allow storage for this site and sign in again.');
  }
  notify();
}
export function clearSession(expectedToken?: string) {
  if (expectedToken !== undefined && expectedToken !== getToken()) return false;
  removeStoredSession();
  notify();
  return true;
}
